export default "__VITE_ASSET__DY8iTln2__"